import './home.scss';

import React from 'react';
import { Link } from 'react-router-dom';
import { Translate } from 'react-jhipster';
import { connect } from 'react-redux';
import { Row, Col, Alert } from 'reactstrap';

import { IRootState } from 'app/shared/reducers';
import { getLoginUrl } from 'app/shared/util/url-utils';

export type IHomeProp = StateProps;

export const Home = (props: IHomeProp) => {
  const { account } = props;

  return (
    account && account.login ? (
      <>Currently nothing</>
    ) : (
      <Row>
        <Col md="9">
          <h2>
          <Translate contentKey="home.title">Welcome, SPB Corporate URL Shortener!</Translate>
          </h2>
          <p className="lead">
            <Translate contentKey="home.subtitle">This is where you can find the documentation you will need to use SPB Corporate URL Shortener service</Translate>
          </p>
          <Alert color="warning">
            <Translate contentKey="global.messages.info.authenticated.prefix">If you want to </Translate>
            <a href={getLoginUrl()} className="alert-link">
              <Translate contentKey="global.messages.info.authenticated.link">sign in</Translate>
            </a>
            <Translate contentKey="global.messages.info.authenticated.suffix">
              , you must have an authorized account.
            </Translate>
          </Alert>
          <p>
            <Translate contentKey="home.question">If you have any question about SPB URL Shortener ..</Translate>
          </p>
        </Col>
        <Col md="3" className="pad">
          <span className="url rounded" />
        </Col>
      </Row>
    )
  );
};

const mapStateToProps = storeState => ({
  account: storeState.authentication.account,
  isAuthenticated: storeState.authentication.isAuthenticated
});

type StateProps = ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps)(Home);
